import { render } from "./CoverAmountCard.vue?vue&type=template&id=326c7259&scoped=true&ts=true"
import script from "./CoverAmountCard.vue?vue&type=script&lang=ts"
export * from "./CoverAmountCard.vue?vue&type=script&lang=ts"

import "./CoverAmountCard.vue?vue&type=style&index=0&id=326c7259&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326c7259"]])

export default __exports__